import Tooltip from "@pathwright/ux/src/components/tooltip/Tooltip"
import moment from "moment"
import Timeago from "../timeago/Timeago"

const When = ({ date, tooltip, ...chakraTooltipProps }) => {
  if (!date) return null

  const timeFormat = "MMM D, YYYY h:mm A"
  const completionTooltip =
    tooltip || (date ? moment(date).format(timeFormat) : null)

  return (
    <span className="When">
      <Tooltip title={completionTooltip} {...chakraTooltipProps}>
        <Timeago date={date} />
      </Tooltip>
    </span>
  )
}

export default When
